const {
    GET_ALL_VEHICULE_REQUEST,
    GET_ALL_VEHICULE_SUCCESS,
    GET_ALL_VEHICULE_FAIL,
    ADD_VEHICULE_REQUEST,
    ADD_VEHICULE_SUCCESS,
    ADD_VEHICULE_FAIL,
    UPDATE_VEHICULE_REQUEST,
    UPDATE_VEHICULE_SUCCESS,
    UPDATE_VEHICULE_FAIL,
    DELETE_VEHICULE_REQUEST,
    DELETE_VEHICULE_SUCCESS,
    DELETE_VEHICULE_FAIL
  } = require("../../actionTypes/Paramaetrage/Vehicule");
  
  function getAllVehicules(state = { data: {} }, action) {
    switch (action.type) {
      case GET_ALL_VEHICULE_REQUEST:
        return { loading: true, data: {} };
      case GET_ALL_VEHICULE_SUCCESS:
        return { loading: false, data: action.payload };
      case GET_ALL_VEHICULE_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function addVehicule(state = { data: {} }, action) {
    switch (action.type) {
      case ADD_VEHICULE_REQUEST:
        return { loading: true, data: {} };
      case ADD_VEHICULE_SUCCESS:
        return { loading: false, data: action.payload };
      case ADD_VEHICULE_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function updateVehicule(state = { data: {} }, action) {
    switch (action.type) {
      case UPDATE_VEHICULE_REQUEST:
        return { loading: true, data: {} };
      case UPDATE_VEHICULE_SUCCESS:
        return { loading: false, data: action.payload };
      case UPDATE_VEHICULE_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function deleteVehicule(state = { data: {} }, action) {
    switch (action.type) {
      case DELETE_VEHICULE_REQUEST:
        return { loading: true, data: {} };
      case DELETE_VEHICULE_SUCCESS:
        return { loading: false, data: action.payload };
      case DELETE_VEHICULE_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  export { addVehicule, updateVehicule, deleteVehicule, getAllVehicules };
  